import { PracticeMethods } from "../utils/numbers.utils";

// API Response Types for Auth
export interface IMeResponse {
  profile: {
    user: string;
    highScore: number;
    totalGamesPlayed: number;
  };
  name: string;
  profileImage: string;
  gameLevel: {
    _id: string;
    name: string;
    practiceMethod: PracticeMethods;
    practiceTime: string;
    digits: number[];
    rows: number;
    numberOfSums: number;
    sortedIndex: number;
  };
}

// API Response Wrappers
export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
  timestamp: string;
}

export interface PaginatedResponse<T> {
  success: boolean;
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  message?: string;
  timestamp: string;
}

// Error Types
export interface ApiError {
  success: false;
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  };
  timestamp: string;
}

export interface IUpdateGameScoreRequest {
  totalCorrect: number;
  totalIncorrect: number;
  totalSums: number;
  timeTaken: number;
  score: number;
}

export interface IUpdateGameScoreResponse {
  totalCorrect: number;
  totalIncorrect: number;
  totalSums: number;
  timeTaken: number;
  score: number;
  date: string;
}

// Error Response Type (for 405 and other errors)
export interface ApiErrorResponse {
  success: false;
  message: string;
  data: null;
  errors: null;
  fieldErrors: null;
}

// Query Keys for React Query
export const QUERY_KEYS = {
  AUTH: "auth",
  GAME: "game",
} as const;
